(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust_box-content"] && !Shopify.designMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-box-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  function initScrollToSection() {
    var scrollPosEnd = 0;
    document.querySelectorAll('.cust-box-content__button').forEach(function(element){
      var section_id = element.getAttribute('href');

      // Only add click event if href starts with "#"
      if (section_id.startsWith("#")) {
        element.onclick = function(e){
          e.preventDefault();
          var sectionElem = document.querySelector(section_id);
          if(sectionElem) {
            var scrollDiv;
            scrollDiv = sectionElem.offsetTop;

            scrollPosEnd = scrollDiv - 100;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
          }
        };
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();
    initScrollToSection();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-section-button-tabs"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelectorAll('.ef-button-tabs--row').length > 0) {
    document.querySelectorAll('.ef-button-tabs--row').forEach(function(elem) {
      elem.querySelectorAll('.ef-section-button-tabs__tab-btn').forEach(function(tab) {

        if (tab.classList.contains('active') == false) {
          var linked_to = tab.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = tab.getAttribute('data-first-section');
            var target_2 = tab.getAttribute('data-second-section');
            var target_3 = tab.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'none';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'none';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'none';
          } else if (linked_to == 'blocks') {
            var block_id = tab.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem) { elem.style.display = 'none'; });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'none';
              }
            }
          }
        }

        tab.addEventListener('click', function(e) {
          var parentElem = this.closest('.ef-button-tabs--row');
          var current_target_1 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-first-section');
          var current_target_2 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-second-section');
          var current_target_3 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-third-section');
          if (current_target_1 != '' && document.querySelector(current_target_1)) document.querySelector(current_target_1).style.display = 'none';
          if (current_target_2 != '' && document.querySelector(current_target_2)) document.querySelector(current_target_2).style.display = 'none';
          if (current_target_3 != '' && document.querySelector(current_target_3)) document.querySelector(current_target_3).style.display = 'none';
          parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').classList.remove('active');
          this.classList.add('active');
          var linked_to = this.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = this.getAttribute('data-first-section');
            var target_2 = this.getAttribute('data-second-section');
            var target_3 = this.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'block';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'block';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'block';
          } else if (linked_to == 'blocks') {
            document.querySelectorAll('.star-page-product-multiple-tab-section .star_product_block').forEach(function(elem) {
              elem.style.display = 'none';
            });
            if (document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').length > 0) {
              document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').forEach(function(elem) {
                elem.style.display = 'none';
              });
            }
            var block_id = this.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem, index) {
                var products_count = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count');
                var products_count_m = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count-m');
                if (window.innerWidth < 750) {
                  if (index < products_count_m) elem.style.display = 'flex';
                } else {
                  if (index < products_count) elem.style.display = 'flex';
                }
              });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                if (window.innerWidth < 750) {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideMobile'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                } else {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideDesktop'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                }
              }
            }
          }
          if (typeof alignProductTitleRow === 'function') alignProductTitleRow();
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-grid-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const btn = document.querySelector('.m11-bf-grid__btn');
        const wrapper = document.querySelector('.m11-bf-grid__popup');
        const closeIcon = document.querySelector('.m11-bf-grid__popup .close-icon');
        btn.addEventListener('click', function(){
            wrapper.style.display = 'block';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();
})();
